import React, { useState } from "react";
import "./ScenarioCard.css";
import DecisionOptions from "./DecisionOptions";
import ResponsibilityCards from "./ResponsibilityCards";
import ExplanationArea from "./ExplanationArea";

const ScenarioCard = ({
  scenario,
  userDecision,
  userExplanation,
  onDecisionChange,
  onExplanationChange,
  language,
}) => {
  const [showCards, setShowCards] = useState(false);

  const handleDecisionSubmit = (decision) => {
    onDecisionChange(decision);
    setShowCards(true);
  };

  const getDecisionButtonText = () => {
    if (language === "zh") {
      return userDecision ? "修改决策" : "开始决策";
    }
    return userDecision ? "Modify Decision" : "Make Decision";
  };

  const getCardsButtonText = () => {
    if (language === "zh") {
      return showCards ? "隐藏责任卡片" : "查看责任卡片";
    }
    return showCards
      ? "Hide Responsibility Cards"
      : "View Responsibility Cards";
  };

  return (
    <div className="scenario-card">
      <div className="scenario-header">
        <h2 className="scenario-title">{scenario.title}</h2>
        <div className="scenario-role">
          <span className="role-label">
            {language === "zh" ? "角色：" : "Role:"}
          </span>
          <span className="role-text">{scenario.role}</span>
        </div>
      </div>

      <div className="scenario-content">
        <div className="background-section">
          <h3>{language === "zh" ? "背景" : "Background"}</h3>
          <p className="background-text">{scenario.background}</p>
        </div>

        <div className="ai-result-section">
          <h3>{language === "zh" ? "AI分析结果" : "AI Analysis Result"}</h3>
          <div className="ai-result-box">
            <p className="ai-result-text">{scenario.ai_result}</p>
          </div>
        </div>

        <div className="question-section">
          <h3 className="question-text">{scenario.question}</h3>
        </div>

        <div className="decision-section">
          <DecisionOptions
            options={scenario.decisionOptions}
            selectedOption={userDecision}
            onOptionSelect={handleDecisionSubmit}
            language={language}
          />
        </div>

        {userDecision && (
          <div className="explanation-section">
            <ExplanationArea
              prompt={scenario.explanationPrompt}
              value={userExplanation}
              onChange={onExplanationChange}
              language={language}
            />
          </div>
        )}

        <div className="cards-section">
          <button
            className="toggle-cards-button"
            onClick={() => setShowCards(!showCards)}
          >
            {getCardsButtonText()}
          </button>

          {showCards && (
            <ResponsibilityCards
              cards={scenario.responsibility_cards}
              language={language}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ScenarioCard;
